import React from "react";
import classNames from "classnames";
import { Rank } from "../../core/types";
import Heading, { types } from "../../elements/Heading";
import Link, { LinkTypes } from "../../elements/Link";
import { TileType } from "./TypeTypes";
import getClassNameFactory from "../../utilities/classNames";

var Tile = function Tile(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      description = _ref.description,
      linkTitle = _ref.linkTitle,
      href = _ref.href,
      newWindow = _ref.newWindow,
      type = _ref.type,
      headingRank = _ref.headingRank;
  var getClassName = getClassNameFactory(Tile.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(type)
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "iconTitle"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "title"
    })
  }, /*#__PURE__*/React.createElement(Heading, {
    rank: headingRank,
    type: types.Small
  }, /*#__PURE__*/React.createElement("b", null, title)))), /*#__PURE__*/React.createElement("p", {
    className: getClassName({
      descendantName: "content"
    })
  }, description), linkTitle && href && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "link"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: href,
    newWindow: newWindow,
    type: LinkTypes.PRIMARY
  }, linkTitle)));
};

Tile.defaultProps = {
  type: TileType.center,
  headingRank: Rank.Second
};
Tile.displayName = "Tile";
export default Tile;